import { render, staticRenderFns } from "./SeksenDokuzForm.vue?vue&type=template&id=5652636a&scoped=true"
import script from "./SeksenDokuzForm.vue?vue&type=script&lang=ts"
export * from "./SeksenDokuzForm.vue?vue&type=script&lang=ts"
import style0 from "./SeksenDokuzForm.vue?vue&type=style&index=0&id=5652636a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652636a",
  null
  
)

export default component.exports